import { defineStore } from 'pinia';
import type { NetPromoterScore } from '../models/NetPromoterScore';
import { comApi } from '@/http/api';
import commissioningApiClient from '@/http/commissioningApiClient';
import { resolveHttpErrorMessage } from '@/http/http-error';

const DEFAULT_NET_PROMOTER_SCORE = 7;

export const useNpsStore = defineStore('nps', {
  state: (): NetPromoterScore => ({
    score: DEFAULT_NET_PROMOTER_SCORE,
    comment: '',
    persisted: false,
  }),
  actions: {
    resetNetPromoterScore() {
      this.$reset();
    },

    setNetPromoterScore(netPromoterScore: NetPromoterScore) {
      this.score = netPromoterScore.score;
      this.comment = netPromoterScore.comment;
    },

    async submitNetPromoterScore(
      serialNumber: string,
      netPromoterScore: NetPromoterScore,
      page: string,
    ): Promise<void> {
      if (this.persisted) {
        return; // Already submitted before
      }

      const commandEndpoint = comApi.netPromoterScore;
      try {
        await commissioningApiClient.post(commandEndpoint, {
          score: netPromoterScore.score,
          comment: netPromoterScore.comment,
          environment: navigator.userAgent,
          page,
          meter: serialNumber,
        });

        this.persisted = true;
        this.setNetPromoterScore(netPromoterScore);

      } catch (error) {
        this.persisted = false;
        throw new Error(
          resolveHttpErrorMessage(
            error,
            'Error submitting the net promoter score. Please try again.',
          ),
        );
      }
    },
  },
});
